var map = {
	"./ADA.svg": 589,
	"./BCH.svg": 590,
	"./BNB.svg": 591,
	"./BTC.svg": 592,
	"./CHZ.svg": 593,
	"./DASH.svg": 594,
	"./DOGE.svg": 595,
	"./DOT.svg": 596,
	"./ETC.svg": 597,
	"./ETH.svg": 598,
	"./EUR.svg": 599,
	"./GBP.svg": 600,
	"./LINK.svg": 601,
	"./LTC.svg": 602,
	"./MATIC.svg": 603,
	"./MKR.svg": 604,
	"./SHIB.svg": 605,
	"./SOL.svg": 606,
	"./TRX.svg": 607,
	"./UNI.svg": 608,
	"./USD.svg": 609,
	"./USDT.svg": 610,
	"./XLM.svg": 611,
	"./XMR.svg": 612,
	"./XRP.svg": 613,
	"./documents.svg": 614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 588;